const Timer = ({
  time = 0,
  running = false,
  onClick
}) => {
  const minutes = Math.floor(time / 60)
  const seconds = time % 60
  const display = `${minutes}:${seconds.toString().padStart(2, '0')}`

  return (
    <svg
      viewBox="0 0 90 110"
      width={85}
      height={100}
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default' }}
    >
      <defs>
        {/* Timer body gradient */}
        <linearGradient id="timer-body" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#F8FAFC" />
          <stop offset="50%" stopColor="#E2E8F0" />
          <stop offset="100%" stopColor="#CBD5E0" />
        </linearGradient>

        {/* Timer face gradient */}
        <radialGradient id="timer-face" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="85%" stopColor="#F8FAFC" />
          <stop offset="100%" stopColor="#E2E8F0" />
        </radialGradient>

        {/* Shadow */}
        <filter id="timer-shadow" x="-15%" y="-10%" width="130%" height="130%">
          <feDropShadow dx="2" dy="3" stdDeviation="3" floodOpacity="0.25"/>
        </filter>
      </defs>

      <g filter="url(#timer-shadow)">
        {/* Timer body */}
        <circle
          cx="45" cy="45" r="40"
          fill="url(#timer-body)"
          stroke="#94A3B8"
          strokeWidth="2"
        />

        {/* Timer face */}
        <circle
          cx="45" cy="45" r="34"
          fill="url(#timer-face)"
          stroke={running ? 'var(--secondary)' : '#CBD5E0'}
          strokeWidth="3"
        />

        {/* Running indicator ring */}
        {running && (
          <circle
            cx="45" cy="45" r="34"
            fill="none"
            stroke="var(--secondary)"
            strokeWidth="3"
            strokeDasharray="213.6"
            strokeDashoffset={213.6 * (1 - time / 60)}
            style={{ transition: 'stroke-dashoffset 0.5s linear' }}
            transform="rotate(-90 45 45)"
          />
        )}
      </g>

      {/* Clock marks - major */}
      {[0, 90, 180, 270].map((angle, i) => (
        <line
          key={i}
          x1="45" y1="15"
          x2="45" y2="20"
          stroke="#475569"
          strokeWidth="2.5"
          strokeLinecap="round"
          transform={`rotate(${angle} 45 45)`}
        />
      ))}

      {/* Clock marks - minor */}
      {[30, 60, 120, 150, 210, 240, 300, 330].map((angle, i) => (
        <line
          key={i}
          x1="45" y1="16"
          x2="45" y2="19"
          stroke="#94A3B8"
          strokeWidth="1.5"
          strokeLinecap="round"
          transform={`rotate(${angle} 45 45)`}
        />
      ))}

      {/* Time display */}
      <text
        x="45" y="50"
        fontSize="16"
        fill={running ? 'var(--secondary)' : '#1E293B'}
        textAnchor="middle"
        fontWeight="700"
        fontFamily="'Courier New', monospace"
      >
        {display}
      </text>

      {/* Top button */}
      <rect
        x="39" y="2" width="12" height="7"
        fill="#64748B"
        rx="2"
      />

      {/* Running pulse indicator */}
      {running && (
        <circle
          cx="45" cy="65" r="4"
          fill="var(--secondary)"
          style={{ animation: 'pulse 1s ease-in-out infinite' }}
        />
      )}

      {/* Label - larger and clearer */}
      <text
        x="45" y="100"
        fontSize="12"
        fill="var(--text-primary)"
        textAnchor="middle"
        fontWeight="600"
      >
        {running ? 'Settling...' : 'Timer'}
      </text>
    </svg>
  )
}

export default Timer
